var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"il-refinance-resend-button"},[_c('RiseupButton',{attrs:{"title":_vm.buttonText,"disabled":_vm.isDisabled,"action":_vm.onResendClick,"size":'large',"variant":'secondary'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }